import { convertMarkupHtmlToString } from 'shared/entities/markup';

import { IPluginsStore } from '../../store/pluginsStore';
import { IRootStore } from '../../store/rootStore';
import { createBaseSendMessageActualNameBase } from '../BaseSendMessage';
import { createActualBlockName, normalizeCommonFields } from '../common';

import { ActionSendMessageNormalizer } from './client';

export const normalizeActionSendMessage: ActionSendMessageNormalizer = (
  raw,
  stores: { rootStore: IRootStore; pluginsStore: IPluginsStore }
) => {
  const text = convertMarkupHtmlToString(raw.params.markup);

  return {
    ...normalizeCommonFields(raw, stores),
    actualName: (t) =>
      createActualBlockName({
        paramsName: createBaseSendMessageActualNameBase(text),
        blockKind: raw.kind,
        blockName: raw.name,
        t,
        ...stores
      })
  };
};
